import React from 'react';

import LanguageIcon from '@mui/icons-material/Language';
import TwitterIcon from '@mui/icons-material/Twitter';
import { Box, IconButton, Link, Stack, Tooltip, Typography } from '@mui/material';

import { DiscordIcon } from '../Icons/DiscordIcon';

import { useStyles } from './styled';

import { NftCardHeader } from '.';

export const NFTHeader = (props) => {
  const { social_handles, logo_url, artist_details } = props;
  const { twitter_url, website_url, discord_url } =
    social_handles && social_handles.length > 0 ? social_handles[0] : {};
  const { artist_name, artist_twitter_id } =
    artist_details && artist_details.length > 0 ? artist_details[0] : {};
  const classes = useStyles();

  const getSocialHandles = () => {
    return (
      <Stack direction="row" justifyContent="center" className={classes.socialHandleContainer}>
        {twitter_url ? (
          <Tooltip title="Twitter">
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              disabled={twitter_url ? false : true}
              href={twitter_url}
              target="_blank">
              <TwitterIcon sx={{ color: twitter_url ? '#3d79e9' : '#c1bfbf' }} />
            </IconButton>
          </Tooltip>
        ) : null}

        {website_url ? (
          <Tooltip title="Webiste">
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              disabled={website_url ? false : true}
              href={website_url}
              target="_blank">
              <LanguageIcon sx={{ color: website_url ? '#3d79e9' : '#c1bfbf' }} />
            </IconButton>
          </Tooltip>
        ) : null}

        {discord_url ? (
          <Tooltip title="Discord">
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              disabled={discord_url ? false : true}
              href={discord_url}
              target="_blank">
              <DiscordIcon sx={{ color: discord_url ? '#3d79e9' : '#c1bfbf' }} />
            </IconButton>
          </Tooltip>
        ) : null}
      </Stack>
    );
  };

  return (
    <Box>
      <NftCardHeader image={logo_url} {...props} />
      <Stack sx={{ mt: 15 }}>
        {artist_name && (
          <Stack direction="row" justifyContent="center">
            <Typography variant="subtitle2" sx={{ mr: 1 }}>{`Created by  `}</Typography>
            {artist_twitter_id ? (
              <Link
                variant="subtitle2"
                // href={sale_item.details_link}
                underline="hover"
                target="_blank"
                rel="noopener">
                {artist_name}
              </Link>
            ) : (
              <Typography variant="subtitle2" sx={{ mr: 1 }}>
                {artist_name}
              </Typography>
            )}
          </Stack>
        )}
        {getSocialHandles()}
      </Stack>
    </Box>
  );
};
